import { BaseService } from './BaseService';
import { FavoriteDto } from '../types';

class FavoriteService extends BaseService {
  constructor() {
    super('/api/favorites');
  }

  async getFavorites(): Promise<FavoriteDto[]> {
    try {
      const items = await this.get<any[]>('/');
      if (!Array.isArray(items)) return [];
      return items.map(item => ({
        documentId: item.documentId || item.DocumentId,
        folderIds: (item.folderIds || item.FolderIds || []).map((fid: any) => String(fid))
      }));
    } catch (error) {
      console.error('FavoriteService.getFavorites error', error);
      return [];
    }
  }

  async toggleFavorite(documentId: string | number): Promise<boolean> {
    try {
      const response = await this.post<{ isFavorite: boolean }>('/toggle', { documentId });
      return response.isFavorite;
    } catch (error) {
      console.error('FavoriteService.toggleFavorite error', error);
      throw error;
    }
  }

  async addToFolder(documentId: string | number, folderId: string): Promise<void> {
    try {
      await this.post(`/${documentId}/folders/${folderId}`, {});
    } catch (error) {
      console.error('FavoriteService.addToFolder error', error);
      throw error;
    }
  }

  async removeFromFolder(documentId: string | number, folderId: string): Promise<void> {
    try {
      await this.delete(`/${documentId}/folders/${folderId}`);
    } catch (error) {
      console.error('FavoriteService.removeFromFolder error', error);
      throw error;
    }
  }
}

export const favoriteService = new FavoriteService();
